module.exports = __webpack_public_path__ + "afee2ee92ed8ecd91a94d3b943b4dd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/games/coh_image_mobile.jpg
// module id = 271
// module chunks = 0